import uiEn from './i18n/en/ui.js'
import permissionsEn from './i18n/en/permissions.js'

import routes from './routes/routes.js'
import leftMenuConfig from './menus/left.js'
import topMenuConfig from './menus/top.js'

export default ({ addLeftMenuItem, addTopMenuItem, addTranslations, addPermissionTranslations, router }) => {
  addTranslations('en', uiEn, 'directSecureTransfer')
  addPermissionTranslations('en', permissionsEn)

  routes.forEach(route => {
    router.addRoute(route)
  })

  if (leftMenuConfig.items) {
    leftMenuConfig.items.forEach(item => {
      addLeftMenuItem(item)
    })
  }

  if (topMenuConfig.items) {
    topMenuConfig.items.forEach(item => {
      addTopMenuItem(item)
    })
  }
}
